<template lang="pug">
  v-container.fill-height.align-start.flex-column(fluid)
    v-snackbar( v-model="snackbar" :color="snackbarColor" ) {{ snackbarMessage }}
      template( v-slot:action="{attrs}")
        v-btn(text v-bind="attrs"
          @click="errorSnackbar = false") {{ $t('buttons.closeButtonLabel') }}
    BillingDetailDialog(v-if="showBillingDetailDialog" :showBillingDetailDialog="showBillingDetailDialog"
      :invoice="selectedBilling" @closeDialog="closeDialog")
    //NewBillingDialog(v-if="showNewBillingDialog" :showNewBillingDialog="showNewBillingDialog"
    //  @closeDialog="closeDialog($event)")
    //DeleteBillingDialog(v-if="showDeleteBillingDialog" :showDeleteBillingDialog="showDeleteBillingDialog"
    //  @closeDialog="closeDialog($event)" :selectedBillings="currentSelection")
    v-container(style="padding: 12px 0")
      v-card-title(style=" padding: 25px 0 ") {{ $t('billingPage.pageTitle') }} {{ timeFilterInPageTitle }}
      v-toolbar(flat)
        //v-btn.newBilling.mr-1(@click="onNewBillingButtonClick" color="primary")
        //  v-icon( small left ) fas fa-plus
        //  span {{ $t('billingPage.newBillingButtonLabel') }}
        //v-btn.ml-1(:disabled="isDeleteButtonDisabled" @click="onDeleteBillingButtonClick" ) {{ $t('billingPage.deleteBillingButtonLabel') }} {{ selectionCount }}
        v-btn(text icon @click="onRefreshGridClick")
          v-icon far fa-sync-alt
        v-divider.mr-4(vertical)
        v-col(cols="3").pl-0
            v-select(
                  v-model="month"
                  :items="months"
                  item-text="name"
                  item-value="date"
                  outlined
                  append-icon="fal fa-chevron-down"
                  return-object
                  @change="onMonthSelectChange"
                  :label=" $t('billingPage.monthAndYearFilter') "
                  clearable
                  clear-icon="fal fa-times"
                  hide-details)

        v-spacer
        v-col(cols="3").pr-0.mr-2
          v-menu(ref="menuFrom"
            v-model="menuFrom"
            :close-on-content-click="false"
            :return-value.sync="dateFrom"
            transition="scale-transition"
            offset-y
            min-width="auto")
            template( v-slot:activator="{ on, attrs }")
              v-text-field(v-model="formattedDateFrom"
                outlined
                :label=" $t('billingPage.dateFromFilter') "
                prepend-inner-icon="fas fa-calendar-alt"
                @click:prepend-inner="menuFrom=true"
                readonly
                v-bind="attrs"
                v-on="on"
                @click:clear="dateFrom = ''"
                hide-details
                clearable
                clear-icon="fal fa-times")
            v-date-picker(v-model="dateFrom"
              @change="saveFrom(dateFrom)"
              no-title
              :min="minAllowedDate"
              :max="maxAllowedDate"
              first-day-of-week="1"
              show-week
              prev-icon="fas fa-chevron-left"
              next-icon="fas fa-chevron-right")
              v-spacer
              v-btn(text
              color="primary"
                @click="menuFrom = false") {{ $t('buttons.cancelButtonLabel') }}
        v-col(cols="3")
          v-menu(ref="menuTo"
            v-model="menuTo"
            :close-on-content-click="false"
            :return-value.sync="dateTo"
            transition="scale-transition"
            offset-y
            min-width="auto")
            template( v-slot:activator="{ on, attrs }")
              v-text-field(v-model="formattedDateTo"
                outlined
                :label=" $t('billingPage.dateToFilter') "
                prepend-inner-icon="fas fa-calendar-alt"
                @click:prepend-inner="menuTo=true"
                readonly
                hide-details
                v-bind="attrs"
                v-on="on"
                @click:clear="dateTo = ''"
                clearable
                clear-icon="fal fa-times")
            v-date-picker(v-model="dateTo"
              @change="saveTo(dateTo)"
              no-title
              :min="minAllowedDate"
              :max="maxAllowedDate"
              first-day-of-week="1"
              show-week
              prev-icon="fas fa-chevron-left"
              next-icon="fas fa-chevron-right")
              v-spacer
              v-btn(text
              color="primary"
                @click="menuTo = false") {{ $t('buttons.cancelButtonLabel') }}
        v-btn( color="primary" @click="onDatesFilterConfirmClick") {{ $t('buttons.confirmDatesFilterButtonLabel')}}
        //v-btn-toggle(v-model="defaultPaymentFilterButton")
        //  v-btn.mr-2(@click="onUnpaidFilterButtonClick" :disabled="this.allFilterActive") {{ $t('billingPage.notPayedFilterButtonLabel') }}
        //v-divider(vertical)
        //v-btn-toggle(v-model="defaultTimeFilterButton")
        //  v-btn.ml-2(@click="onMonthFilterButtonClick") {{ $t('billingPage.monthFilterButtonLabel') }}
        //  v-btn(@click="onYearFilterButtonClick") {{ $t('billingPage.yearFilterButtonLabel') }}
        //  v-btn(@click="onAllFilterButtonClick") {{ $t('billingPage.allFilterButtonLabel') }}
    v-container.pa-0.flex-shrink-0.flex-grow-1
      AgGridVue.mt-2.ag-theme-balham(style="width: 100%; height: 100%; min-height: 500px;"
        :gridOptions="gridOptions"
        :columnDefs="columnDefs"
        :rowData="rowData"
        :pinnedBottomRowData="pinnedRowData"
        :localeTextFunc="localeTextFunc"
        @grid-ready="onGridReady"
        @selection-changed="onSelectionChange"
        @row-double-clicked="onBillingRowDoubleClick"
        :frameworkComponents="gridFrameworkComponents")
</template>

<script lang="ts">
import {AgGridVue} from "ag-grid-vue";
import {Component} from "vue-property-decorator";
import Vue from "vue";
import {
  ColDef,
  ColumnApi,
  GridApi,
  GridOptions,
  ICellRendererParams, RowClickedEvent, RowNode,
  ValueFormatterParams, ValueGetterParams,
} from "ag-grid-community";
import BillingDetailDialog from "@/components/billing/BillingDetailDialog.vue";
import NewBillingDialog from "@/components/billing/NewBillingDialog.vue";
import DeleteBillingDialog from "@/components/billing/DeleteBillingDialog.vue";
import StatusCircle from "@/components/billing/StatusCircle.vue";
import moment from "moment";
import {Action} from "vuex-class";
import {FETCH_BILLINGS} from "@/store/action-types";
import {FilterBillingsPayload, FilterBillingsPayloadWithCancelToken} from "@/types/payload";
import axios, {CancelTokenSource} from "axios";
import {MonthFilter} from "@/types";
import {Invoice} from "@/model/billing/Invoice";
import {formatIntPrice} from "@/services/formatter";
import StatusFilter from "@/components/billing/StatusFilter.vue";
import BillingCustomStatusPanel from "@/components/billing/BillingCustomStatusPanel.vue";

@Component({
  components: {
    AgGridVue,
    BillingDetailDialog,
    NewBillingDialog,
    DeleteBillingDialog,
    BillingCustomStatusPanel
  }
})

export default class BillingPage extends Vue {
  $refs!: {
    menuFrom: Vue & {
      save(date: string): void,
    },
    menuTo: Vue & {
      save(date: string): void,
    },
  }

  @Action(FETCH_BILLINGS) fetchInvoices!: { (payload: FilterBillingsPayloadWithCancelToken): Promise<Invoice[]> }

  private gridOptions: GridOptions = {}
  // noinspection JSMismatchedCollectionQueryUpdate
  private columnDefs: ColDef[] = []
  // noinspection JSMismatchedCollectionQueryUpdate
  private rowData: Invoice[] = []
  private gridApi: GridApi | null = null
  private columnApi: ColumnApi | null = null
  private gridFrameworkComponents = {}
  private billings: Invoice[] = []
  private selectedBilling: Invoice | null = null
  private currentSelection: Invoice[] = []
  private pinnedRowData: any = [];

  private unpaidFilterActive: boolean = true
  private monthFilterActive: boolean = false
  private yearFilterActive: boolean = false
  private allFilterActive: boolean = true

  private snackbar: boolean = false
  private snackbarMessage: string = ''
  private snackbarColor: string = ''

  private showBillingDetailDialog: boolean = false
  private showNewBillingDialog: boolean = false
  private showDeleteBillingDialog: boolean = false

  private defaultPaymentFilterButton: number = 0
  private defaultTimeFilterButton: number = 2

  private cancelToken: CancelTokenSource | null = null

  private dateFrom: string = ''
  private dateTo: string = ''
  private menuFrom: boolean = false
  private menuTo: boolean = false
  private formattedDateFrom: string = ''
  private formattedDateTo: string = ''
  private minAllowedDate: string = moment([2020, 8]).startOf('month').format('YYYY-MM-DD')
  private maxAllowedDate: string = moment().add(1, 'month').endOf('month').format('YYYY-MM-DD')
  private defaultMinDate: string = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD')
  private defaultMaxDate: string = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')

  private month: MonthFilter | null = null
  private months: MonthFilter[] = []
  private name: string = ""
  private statusFilterParams = { cellRenderer: 'statusFilter' }
  private localeTextFunc: Function | null = null
  private isRangeFilter: boolean = false

  onRefreshGridClick (): void{
    if(this.month) {
      let payload: FilterBillingsPayload = {
        after: moment(this.month?.date).startOf('month').format('YYYY-MM-DD'),
        before: moment(this.month?.date).endOf('month').format('YYYY-MM-DD')
      }
      this.fetchBillingsList(payload)
    } else if(this.dateFrom && this.dateTo){
      this.onDatesFilterConfirmClick()
    } else {
        let payload: FilterBillingsPayload = {
          after: this.minAllowedDate,
          before: this.maxAllowedDate
      }
        this.fetchBillingsList(payload)
    }
  }

  calculatePinnedRowData(dataset: Invoice[]): any[] {
    let totalAmountToPay = 0
    let totalAmountAlreadyPaid = 0
    let totalPriceItemSum = 0

    dataset.forEach(i => {
      totalAmountToPay += i.outstandingAmountToPay
      totalAmountAlreadyPaid += i.amountAlreadyPaid
      totalPriceItemSum += i.priceItemSum
    })

    return [{
      status: null,
      issueDate: null,
      period: null,
      boarder: " ",
      formattedOutstandingAmountToPay: formatIntPrice(totalAmountToPay),
      formattedAmountAlreadyPaid: formatIntPrice(totalAmountAlreadyPaid),
      formattedPriceItemSum: formatIntPrice(totalPriceItemSum)
    }];
  }

  get selectionCount(): string {
    const count = this.currentSelection.length

    if (count > 0) {
      return `(${count})`
    }

    return ''
  }

  get isDeleteButtonDisabled(): boolean {
    return this.currentSelection.length === 0
  }

  get timeFilterInPageTitle(): string {
    if (this.monthFilterActive) {
      let from = moment().subtract(1, 'months').startOf('month')
      let to = moment()
      if (moment(from).toDate().getFullYear() === moment(to).toDate().getFullYear()) {
        return moment(from).format('D.M.') + ' - ' + moment(to).format('D.M.YYYY')
      } else {
        return moment(from).format('D.M.YYYY') + ' - ' + moment(to).format('D.M.YYYY')
      }
    } else if (this.yearFilterActive) {
      return moment().subtract(1, 'years').format('D.M.YYYY') + ' - ' + moment().format('D.M.YYYY')
    } else {
      return ''
    }
  }

  onClearField () {

  }

  onMonthSelectChange () {
    let payload: FilterBillingsPayload = {
      after: this.month ? moment(this.month?.date).startOf('month').format('YYYY-MM-DD') : this.minAllowedDate,
      before: this.month ? moment(this.month?.date).endOf('month').format('YYYY-MM-DD') : this.maxAllowedDate
    }
    this.isRangeFilter = false

    this.fetchBillingsList(payload)
    this.dateTo = ''
    this.formattedDateTo = ''
    this.dateFrom = ''
    this.formattedDateFrom = ''
  }

  onDatesFilterConfirmClick(): void {
    this.month = null
    if (this.dateFrom && this.dateTo) {
      if (Date.parse(this.dateFrom) < Date.parse(this.dateTo)) {
        let payload: FilterBillingsPayload = {
          after: this.dateFrom,
          before: this.dateTo
        }
        this.isRangeFilter = true
        this.fetchBillingsList(payload)
      } else {
        this.snackbar = true
        this.snackbarMessage = this.$t('billingPage.invalidDateCombinationWarning').toString()
        this.snackbarColor = "warning"
      }

    } else if (this.dateFrom && !this.dateTo) {
      let payload: FilterBillingsPayload = {
        after: this.dateFrom,
        before: moment().format('YYYY-MM-DD')
      }
      this.fetchBillingsList(payload)
    } else {
      this.snackbar = true
      this.snackbarMessage = this.$t('billingPage.pickDateFromFilterWarning').toString()
      this.snackbarColor = "warning"
    }
  }

  saveFrom(date: string): void {
    this.$refs.menuFrom.save(date)
    this.getFormattedDateFrom(date)
  }

  saveTo(date: string): void {
    this.$refs.menuTo.save(date)
    this.getFormattedDateTo(date)
  }

  getFormattedDateFrom(date?: string): string {
    if (date) {
      return this.formattedDateFrom = moment(date).format('D.M.YYYY')
    } else {
      return this.formattedDateFrom = moment(this.dateFrom).format('D.M.YYYY')
    }
  }

  getFormattedDateTo(date?: string): string {
    if (date) {
      return this.formattedDateTo = moment(date).format('D.M.YYYY')
    } else {
      return this.formattedDateTo = moment(this.dateTo).format('D.M.YYYY')
    }
  }

  onGridReady(params: ICellRendererParams) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
  }

  onSelectionChange(params: GridOptions): void {
    this.currentSelection = params.api!.getSelectedRows()
  }

  async fetchBillingsList(payload?: FilterBillingsPayload): Promise<void> {
    setTimeout(() => {this.gridOptions.api?.showLoadingOverlay()}, 0)

    if (this.cancelToken) {
      this.cancelToken.cancel()
    }

    this.cancelToken = axios.CancelToken.source()

    let finalPayload: FilterBillingsPayload

    /*if (this.unpaidFilterActive) {
      finalPayload = {
        after: payload?.after,
        before: payload?.before,
        unpaid: 1
      }
    } else {
      finalPayload = {
        after: payload?.after,
        before: payload?.before
      }
    }*/

    finalPayload = {
      after: payload?.after,
      before: payload?.before
    }

    let payloadWithCancelToken: FilterBillingsPayloadWithCancelToken = {
      payload: finalPayload,
      cancelToken: this.cancelToken
    }

    try {
      this.billings = await this.fetchInvoices(payloadWithCancelToken)
      if(this.isRangeFilter) {
        this.billings.sort((a: Invoice,b:Invoice) => {
          return moment(a.issueDate).unix() - moment(b.issueDate).unix()
        })
      }
      this.rowData = this.billings
      this.pinnedRowData = this.calculatePinnedRowData(this.billings)
      this.cancelToken = null
    } catch (e) {
      if ((e as any).isCancel(e)) {

      } else {
        this.snackbar = true
        this.snackbarMessage = this.$t('errors.fetchDataError').toString()
        this.snackbarColor = 'error'
      }
    } finally {
      this.gridOptions.api?.hideOverlay()
    }
  }

  onUnpaidFilterButtonClick() {
    this.unpaidFilterActive = !this.unpaidFilterActive

    if (this.unpaidFilterActive) {
      if (this.monthFilterActive) {
        let payload: FilterBillingsPayload = {
          after: moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
          before: moment().format('YYYY-MM-DD')
        }
        this.fetchBillingsList(payload)
      } else if (this.yearFilterActive) {
        let payload: FilterBillingsPayload = {
          after: moment().subtract(1, 'years').format('YYYY-MM-DD'),
          before: moment().format('YYYY-MM-DD')
        }
        this.fetchBillingsList(payload)
      } else {
        this.fetchBillingsList()
      }
    } else if (this.monthFilterActive) {
      let payload: FilterBillingsPayload = {
        after: moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
        before: moment().format('YYYY-MM-DD')
      }

      this.fetchBillingsList(payload)
    } else if (this.yearFilterActive) {
      let payload: FilterBillingsPayload = {
        after: moment().subtract(1, 'years').format('YYYY-MM-DD'),
        before: moment().format('YYYY-MM-DD')
      }

      this.fetchBillingsList(payload)
    }
  }

  onMonthFilterButtonClick() {
    this.monthFilterActive = !this.monthFilterActive
    this.yearFilterActive = false
    this.allFilterActive = false

    if (this.monthFilterActive) {
      let payload: FilterBillingsPayload = {
        after: moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
        before: moment().format('YYYY-MM-DD')
      }

      this.fetchBillingsList(payload)
    } else if (this.unpaidFilterActive) {
      this.fetchBillingsList()
    }
  }

  onYearFilterButtonClick() {
    this.yearFilterActive = !this.yearFilterActive
    this.monthFilterActive = false
    this.allFilterActive = false


    if (this.yearFilterActive) {
      let payload: FilterBillingsPayload = {
        after: moment().subtract(1, 'years').format('YYYY-MM-DD'),
        before: moment().format('YYYY-MM-DD')
      }

      this.fetchBillingsList(payload)
    } else if (this.unpaidFilterActive) {
      this.fetchBillingsList()
    }
  }

  onAllFilterButtonClick() {
    this.allFilterActive = !this.allFilterActive
    this.monthFilterActive = false
    this.yearFilterActive = false

    if (this.unpaidFilterActive) {
      this.fetchBillingsList()
    }
  }

  onBillingRowDoubleClick(params: RowClickedEvent): void {
    this.selectedBilling = params.data
    this.showBillingDetailDialog = true
  }

  onNewBillingButtonClick(): void {
    this.showNewBillingDialog = true
  }

  onDeleteBillingButtonClick(): void {
    this.showDeleteBillingDialog = true
  }

  closeDialog(event: boolean): void {
    if (this.showBillingDetailDialog) {

      this.showBillingDetailDialog = false

    } else if (this.showNewBillingDialog) {
      if (event) {
        this.refreshBillingsListWithActiveFilters()
      }

      this.showNewBillingDialog = false

    } else if (this.showDeleteBillingDialog) {
      if (event) {
        this.snackbar = true
        this.snackbarColor = 'success'
        this.snackbarMessage = this.$t('success.deleteDataSuccess').toString()
      }
      this.showDeleteBillingDialog = false
    }
  }

  refreshBillingsListWithActiveFilters() {

    if (this.unpaidFilterActive) {
      if (this.monthFilterActive) {
        let payload: FilterBillingsPayload = {
          after: moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
          before: moment().format('YYYY-MM-DD')
        }
        this.fetchBillingsList(payload)
      } else if (this.yearFilterActive) {
        let payload: FilterBillingsPayload = {
          after: moment().subtract(1, 'years').format('YYYY-MM-DD'),
          before: moment().format('YYYY-MM-DD')
        }
        this.fetchBillingsList(payload)
      } else {
        this.fetchBillingsList()
      }
    } else if (this.monthFilterActive) {
      let payload: FilterBillingsPayload = {
        after: moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
        before: moment().format('YYYY-MM-DD')
      }

      this.fetchBillingsList(payload)
    } else if (this.yearFilterActive) {
      let payload: FilterBillingsPayload = {
        after: moment().subtract(1, 'years').format('YYYY-MM-DD'),
        before: moment().format('YYYY-MM-DD')
      }

      this.fetchBillingsList(payload)
    }

    this.onBillingCreated()
  }

  onBillingCreated(): void {
    this.gridOptions.api?.ensureIndexVisible(135, 'middle')
    let rowNode = this.gridApi!.getDisplayedRowAtIndex(135)
    this.gridApi?.flashCells({
      rowNodes: [rowNode],
    })
  }

  createGridOptions(): GridOptions {
    return {
      rowSelection: 'multiple',
        rowDeselection: true,
      rowMultiSelectWithClick: false,
      suppressContextMenu: true,

      // getRowNodeId: (data) => data.id,

      defaultColDef: {
      sortable: true,
        enableCellChangeFlash: true,
    },
      statusBar: {
        statusPanels: [
          { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left' },
          { statusPanelFramework: 'BillingCustomStatusPanel', align: 'left'}
        ],
      },

      cellFadeDelay: 1500,

        onFilterChanged: (params: any) => {
      const dataset = params.api.rowModel.rowsToDisplay.map((r: RowNode) => r.data)

      setTimeout(() => {
        params.api.setPinnedBottomRowData(this.calculatePinnedRowData(dataset))
      }, 0)
    },

      overlayLoadingTemplate:
      `<div class="ag-overlay-loading-center" style="font-size: 15px">
               <i class="fas fa-spinner fa-pulse"></i>
               <span style="padding-left: 10px"> ${this.$t('billingPage.loadingGridDataText')} </span>
           </div>`

    }
  }

  createColDefs(): ColDef[] {
    return [
      {
        field: 'paymentStatus',
        headerName: '',
        filter: 'agSetColumnFilter',
        floatingFilter: true,
        floatingFilterComponentParams: {
          suppressFilterButton: false
        },
        width: 60,
        cellRenderer: 'statusIndicator',
        suppressMenu: false,
        menuTabs:[],
        filterParams: this.statusFilterParams,
      },
      {
        headerName: this.$t('billingPage.issueDateColumnTitle').toString(),
        filter: 'agDateColumnFilter',
        floatingFilter: true,
        floatingFilterComponentParams: {
          suppressFilterButton: true
        },
        filterParams: {
          comparator: (filterLocalDateAtMidnight: any, cellValue: any) => {
            if (cellValue == null) {
              return -1;
            }
            const filterDate = moment(filterLocalDateAtMidnight).format('YYYY-MM-DD')
            const cellDate = moment(cellValue).format('YYYY-MM-DD')
            if (filterDate === cellDate) {
              return 0;
            }
            if (cellDate < filterDate) {
              return -1;
            }
            if (cellDate > filterDate) {
              return 1;
            }
          },
          browserDatePicker: true,
        },
        menuTabs:[],
        suppressMenu: false,
        width: 130,
        valueGetter(params: ValueGetterParams): string {
          return `${params.data.issueDate}`
        },

        valueFormatter(params: ValueFormatterParams): string {
          if (params.node.rowPinned) {
            return ""
          } else {
            return moment(params.value).format('D.M.YYYY')
          }
        }
      },
      {
        headerName: this.$t('billingPage.periodColumnTitle').toString(),
        width: 180,
        menuTabs:[],
        valueGetter(params: ValueGetterParams): string {
          return `${params.data.periodStart} ${params.data.periodEnd}`
        },

        valueFormatter(params: ValueFormatterParams): string {
          if (params.node.rowPinned) {
            return ""
          } else {
            if (moment(params.data.periodStart).toDate().getFullYear() === moment(params.data.periodEnd).toDate().getFullYear()) {
              return moment(params.data.periodStart).locale('SK').format('MMMM YYYY')
            } else {
              return moment(params.data.periodStart).locale('SK').format('MMMM YYYY')
            }
          }
        }
      },
      {
        headerName: this.$t('billingPage.boarderGroupColumnTitle').toString(),
        filter: 'agTextColumnFilter',
        filterParams: {
          debounceMs: 250,
          textFormatter: (value: string) => value.toString().normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
              .toLowerCase()
        },
        floatingFilter: true,
        floatingFilterComponentParams: {
          suppressFilterButton: true
        },
        width: 150,
        menuTabs:[],

        valueGetter(params: ValueGetterParams): string {
          if (params.node.rowPinned) {
            return ""
          } else {
            let text: string = ''
            params.data.boarder.boarderGroupCollection.forEach((item: any, index: number) => {
              text += index === 0 ? item.name : `, ${item.name}`
            })
            return text
          }
        }
      },
      {
        headerName: this.$t('billingPage.boarderColumnTitle').toString(),
        filter: 'agTextColumnFilter',
        filterParams: {
          debounceMs: 250,
          textCustomComparator: (filter: string, value: string, filterText: string) => {
            const filterTextNormalizeLowerCase = filterText.normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '').toLowerCase();
            const valueNormalizeLowerCase = value.toString().normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '').toLowerCase();


            switch (filter) {
              case 'contains':
                let passed = true
                filterTextNormalizeLowerCase.split(' ').forEach((filterWord: string) => {
                  if (valueNormalizeLowerCase.indexOf(filterWord) < 0) {
                    passed = false;
                  }
                })
                return passed;
              default:
                return false;
            }
          }
        },
        floatingFilter: true,
        floatingFilterComponentParams: {
          suppressFilterButton: true
        },
        flex: 1,
        minWidth: 198,
        menuTabs:[],

        valueGetter(params: ValueGetterParams): string {
          if (params.node.rowPinned) {
            return ""
          } else {
            return `${params.data.boarder.person?.familyName} ${params.data.boarder.person?.firstName}`
          }
        }
      },
      {
        headerName: this.$t('billingPage.priceForSumColumnTitle').toString() + ' €',
        field: 'priceItemSumNatural',
        filter: 'agNumberColumnFilter',
        floatingFilter: true,
        floatingFilterComponentParams: {
          suppressFilterButton: false
        },
        menuTabs:[],
        suppressMenu: false,
        width: 150,
        cellStyle: {display: 'flex', 'justify-content': 'end'},
        valueFormatter(params: ValueFormatterParams): string {
          return (params.data as Invoice).formattedPriceItemSum + ' €'
        }
      },
      {
        headerName: this.$t('billingPage.outstandingAmountToPayColumnTitle').toString() + ' €',
        field: 'outstandingAmountToPayNatural',
        filter: 'agNumberColumnFilter',
        floatingFilter: true,
        floatingFilterComponentParams: {
          suppressFilterButton: false
        },
        menuTabs:[],
        suppressMenu: false,
        width: 150,
        cellStyle: {display: 'flex', 'justify-content': 'end'},
        valueFormatter(params: ValueFormatterParams): string {
          return (params.data as Invoice).formattedOutstandingAmountToPay + ' €'
        }
      },
      {
        headerName: this.$t('billingPage.amountAlreadyPayedColumnTitle').toString() + ' €',
        field: 'amountAlreadyPaidNatural',
        filter: 'agNumberColumnFilter',
        floatingFilter: true,
        floatingFilterComponentParams: {
          suppressFilterButton: false
        },
        menuTabs:[],
        suppressMenu: false,
        width: 150,
        cellStyle: {display: 'flex', 'justify-content': 'right'},
        valueFormatter(params: ValueFormatterParams): string {
          return (params.data as Invoice).formattedAmountAlreadyPaid + ' €'
        }
      },
    ]
  }

  beforeMount(): void {
    this.gridOptions = this.createGridOptions()
    this.columnDefs = this.createColDefs()

    this.gridFrameworkComponents = {
      statusIndicator: StatusCircle,
      statusFilter: StatusFilter
    }
  }

  monthsRange(startDate: string, endDate: string) {
    const start = startDate.split('-');
    const end = endDate.split('-');
    const startYear = parseInt(start[0]);
    const endYear = parseInt(end[0]);
    const dates = [];

    for (let i = startYear; i <= endYear; i++) {
      let endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
      let startMon = i === startYear ? parseInt(start[1]) - 1 : 0;
      for (let j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j + 1) {
        let month = j + 1;
        let displayMonth = month < 10 ? '0' + month : month;
        let monthName = moment(displayMonth, 'MM').locale('sk').format('MMMM')
        let monthNameFirstLetterUppercase = monthName.charAt(0).toUpperCase() + monthName.slice(1)
        let monthDate = i + "-" + displayMonth
        let monthObject: MonthFilter = {
          date: new Date(monthDate),
          name: monthNameFirstLetterUppercase + " " + i
        }
        dates.push(monthObject);
      }
    }
    return dates.reverse();
  }

  created () {
    this.localeTextFunc = (key: string, defaultValue: string) => {
      const tKey = `agGrid.${key}`
      const translated = this.$t(tKey)
      if(tKey === translated){
        return defaultValue
      } else {
        return translated
      }

    }
  }

  mounted(): void {
    this.months = this.monthsRange(this.minAllowedDate, this.maxAllowedDate)
    const foundMonth: MonthFilter | undefined = this.months.find((item: any) => moment(item.date).format('YYYY-MM-DD') === this.defaultMinDate)
    this.month = foundMonth ? foundMonth : null

    let payload: FilterBillingsPayload = {
      after: this.defaultMinDate,
      before: this.defaultMaxDate
    }
    this.fetchBillingsList(payload)
  }
}
</script>

<style lang="stylus" scoped>

>>> .v-toolbar__content {
  padding 0
}

.ag-theme-balham >>> .ag-cell-data-changed {
  background-color: yellow !important
}

>>> .ag-text-field-input {
  height 25px

}

.newBilling {
  font-size: 17px;
}

</style>